import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    id: Number
  }

  openDetails(event) {
    // Don't open details if clicking on action buttons or checkbox
    if (event.target.closest('a') || event.target.closest('button') || event.target.closest('input[type="checkbox"]')) {
      return
    }

    // Load details in modal via AJAX
    this.loadDetailsModal()
  }

  async loadDetailsModal() {
    try {
      const response = await fetch(`/admin/media/${this.idValue}.js`, {
        headers: {
          'Accept': 'text/javascript',
          'X-Requested-With': 'XMLHttpRequest'
        }
      })

      if (response.ok) {
        const script = await response.text()
        eval(script) // Execute the JavaScript response
      } else {
        console.error('Failed to load media details')
        // Fallback to navigating to the page
        window.location.href = `/admin/media/${this.idValue}`
      }
    } catch (error) {
      console.error('Error loading media details:', error)
      // Fallback to navigating to the page
      window.location.href = `/admin/media/${this.idValue}`
    }
  }
}
